<template>
  <section class="FileUpload FileManagement">
    <div class="dropZoneWrap">
      <div class="dropZone" v-cloak
        tabindex="0" role="button"
        @dragenter="setCssHighlight(true)"
        @dragleave="setCssHighlight(false)"
        @drop.prevent="replaceWithDropFiles"
        @dragover.prevent
        @keydown.enter="doTriggerClick"
        @click="doTriggerClick"></div>
      <div class="dropZoneInfo" :class="{ cssHighlight: cssHighlight }">
        <div class="textIntro">Um Dateien hinzuzufügen,<br />hier <strong>klicken</strong> oder per <strong>drag &amp; drop</strong> ablegen.</div>
        <Icon :path="mdiArrowUpBoldCircle"></Icon>
        <div class="fileTypesText" v-if="fileTypesText && fileTypesText.length>0">
          <div class="textHeadline">Erlaubte Dateitypen:</div>
          <div class="textFiletypes">{{fileTypesText}}</div>
        </div>
      </div>
    </div>

    <q-file v-show="false" :disabled="disabled" ref="fileInputField" v-model="files" label="Dateien (optional)" use-chips multiple :max-files="maxFiles" :max-total-size="maxTotalSize" @update:modelValue="updateFiles" :accept="allowedMimeTypes.join(',')" />

    <div v-if="errorMessage" class="errorMessage">{{errorMessage}}</div>
  </section>
</template>

<script>
import i18n from './../i18n';
import { mdiArrowUpBoldCircle } from '@quasar/extras/mdi-v7';
import Icon from './Icon.vue';
export default {
  name: 'FileUpload',
  components: { Icon },
  props: {
    //the allowed mime Types (will not filter files that are outside of the specification)
    allowedMimeTypes: { required:false, type: Array, default: () => ([
        'image/jpeg',
        'image/png',
        //'application/pdf',
        //'application/msword', // doc
        //'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
        //'application/x-zip-compressed',
        //'application/zip'
      ]),
    },
    maxFiles: { required:false, type: [Number, Object], default: 10 },
    maxTotalSize: { required:false, type: [Number, Object], default: 1000 * 1000 * 10 }, // 10MB
    fileTypesText: { required:false, type: String, default: 'JPG und PNG' },//JPG, PNG, PDF, DOC, DOCX oder ZIP
    disabled: { required:false, type: Boolean, default: false },
  },
  emits: ['complete'],
  data: () => ({
    files: [],
    loading: false,
    cssHighlight: false,
    errorMessage: false,

    mdiArrowUpBoldCircle,
  }),
  computed: {
    acceptMimeTypesString() {
      if(!this.allowedMimeTypes || !Array.isArray(this.allowedMimeTypes)) return null;
      if(this.allowedMimeTypes.length === 0) return null;
      return this.allowedMimeTypes.join(', ');
    }
  },
  methods:{
    setCssHighlight(value) {
      this.cssHighlight = !!value;
    },
    doTriggerClick() {
      if(this.disabled) return;
      this.$refs.fileInputField.$el.querySelector('input').click();
    },
    replaceWithDropFiles(e) {
      if(this.disabled) return;
      this.files = Array.from(e.dataTransfer.files);
      this.updateFiles();
    },
    async updateFiles() {
      if(this.disabled) return;
      if(!this.files || this.files.length===0) return;
      this.loading = true;
      this.errorMessage = false;

      //filter, so only allowed mime-types can be used
      const filteredFiles = this.files.filter(file => this.allowedMimeTypes.includes(file.type));
      if(filteredFiles.length < this.files.length) {
        this.errorMessage = i18n.tc(
            ' | '+//0-files will not happend
            '{count} Datei entspricht nicht den vorgegebenen Dateitypen und wurde deshalb ignoriert.|'+//1 file
            '{count} Dateien entsprechen nicht den vorgegebenen Dateitypen und wurden deshalb ignoriert.'//2 and more files
          , this.files.length - filteredFiles.length
        );
      }
      this.setCssHighlight(false);
      this.$emit('complete', filteredFiles);
      this.files = [];
    },
  }
}
</script>

<style lang="scss">
.FileManagement.FileUpload {
  .dropZoneWrap {
    position: relative;
  }
  .dropZone {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .dropZoneInfo {
    border: 3px dashed rgba(0,0,0,0.1);
    background:#f0f0f0;
    padding:1em;
    min-height: 15em;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    transition: border .5s ease, background .5s ease;
    position: relative;
    z-index: 1;

    .v-icon { font-size: 50px !important; }

    &.cssHighlight { border-color:rgb(var(--v-theme-primary)); background: #fff; }

    .textIntro { font-size:1.3em; text-align: center; }
    .fileTypesText { text-align: center; line-height: 1.2;
      .textHeadline { font-size:.8em; }
    }
  }

}
</style>